module.exports = __webpack_public_path__ + "img/triangle-down.cd301ce5.svg";